module.exports = {
    "collectionLabel": `\u{5019}\u{88DC}`
};


//# sourceMappingURL=ja-JP.main.js.map
